<template>
  <SettingsModal v-if="triggerSettingsModalVisible" @close="triggerSettingsModalVisible = false" />
  <div id="infuse-navigation-bottom-bar" class="fixed -bottom-0 left-0 w-full bg-neutral-50 px-6 py-2 lg:hidden z-10">
    <!-- justify-content: safe center not yet available in current tailwind version -->
    <div class="flex w-full flex-row gap-2 overflow-x-auto" :style="{ 'justify-content': 'safe center' }">
      <router-link
        v-for="menuItem of menuItems"
        :key="menuItem.name"
        v-permission="{ ids: menuItem.permissionIds }"
        active-class="active"
        :to="menuItem.to"
        class="block"
      >
        <NavigationBottomBarItem>
          <template #icon>
            <component :is="getNavigationIcon(menuItem.icon)" class="h-5 w-5" />
          </template>
          <template #label>
            {{ t(menuItem.name) }}
          </template>
        </NavigationBottomBarItem>
      </router-link>

      <div v-if="showSettings" class="block">
        <NavigationBottomBarItem @click="showSettingsModal">
          <template #icon>
            <component :is="Settings" class="h-5 w-5" />
          </template>
          <template #label>
            {{ t('nav.settings') }}
          </template>
        </NavigationBottomBarItem>
      </div>

      <div class="block">
        <NavigationBottomBarItem @click="$emit('logout')">
          <template #icon>
            <font-awesome-icon :icon="['far', 'arrow-right-from-bracket']" class="h-5 w-5" />
          </template>
          <template #label>
            {{ t('nav.log_out') }}
          </template>
        </NavigationBottomBarItem>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { User } from '@infuse/auth/services';
import { vPermission } from '@infuse/iam/permission/directives';
import { SettingsModal } from '@infuse/ui/components';
import { MenuItem } from '@infuse/ui/domain';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Settings from '../assets/infuse-icons/settings.svg?component';
import NavigationBottomBarItem from './NavigationBottomBarItem.vue';
import { getNavigationIcon } from './NavigationIcons';

interface Props {
  menuItems: MenuItem[];
  user?: User;
  settings?: boolean;
  showSettings?: boolean;
}

const triggerSettingsModalVisible = ref(false);
const { t } = useI18n();

function showSettingsModal() {
  triggerSettingsModalVisible.value = true;
}

defineProps<Props>();
defineEmits(['logout']);
</script>
